// extracted by mini-css-extract-plugin
export var askAiIcon = "_n0-9";
export var container = "_n0-0";
export var groupSeparator = "_n0-a";
export var highlight = "_n0-4";
export var resultIcon = "_n0-5";
export var resultItem = "_n0-7";
export var resultSubtitle = "_n0-3";
export var resultTitle = "_n0-2";
export var resultsList = "_n0-1";
export var searchGroup = "_n0-6";
export var selected = "_n0-8";